{
    "locale": "he-IL",
    "General": {
        "OrText": "או",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "מעבר ל-My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "יצירת חשבון חדש",
        "ButtonText_SignInToYourAccount": "התחברות לחשבון שלך",
        "ButtonText_StartInterviewWithoutSigningUp": "התחלת הראיון ללא הרשמה",
        "ButtonText_StartInterviewWithoutSigningIn": "התחלת הראיון ללא התחברות",
        "Navlink_Dashboard": "לוח הבקרה",
        "Navlink_MyInterviews": "הראיונות שלי",
        "Navlink_LearnWithHubert": "למידה עם Hubert",
        "Navlink_HelpCenter": "מרכז העזרה",
        "MyProfile": "הפרופיל שלי",
        "LogOut": "התנתקות"
    },
    "Login": {
        "MainTitle": "צפייה בתוצאות הראיון שלך ב-Hubert",
        "Subtitle": "אפשר להתחבר כדי לראות תוצאות, לקבל משוב, לקרוא עצות ועוד.",
        "LoginTitle": "התחברות לחשבון Hubert שלך",
        "Label_Email": "אימייל",
        "Label_Password": "סיסמה",
        "ButtonText_SignIn": "התחברות",
        "ButtonText_ForgotPassword": "שכחת סיסמה?",
        "ButtonText_ContinueWithGoogle": "המשך עם Google",
        "OrSeparator": "או",
        "Error_Email_Required": "יש להזין אימייל.",
        "Error_Email_Invalid": "יש להזין כתובת אימייל תקינה.",
        "Error_Password_Required": "יש להזין סיסמה.",
        "Error_Use_Same_Email_As_Interview": "יש להשתמש באותה כתובת אימייל שנמסרה במהלך הראיון."
    },
    "Registration": {
        "MainTitle": "צפייה בתוצאות הראיון שלך ב-Hubert",
        "Subtitle": "אפשר להירשם כדי לראות תוצאות, לקבל משוב, לקרוא עצות ועוד.",
        "RegistrationTitle": "יצירת חשבון Hubert",
        "BenefitsBox_Title": "אפשר",
        "BenefitsBox_Point1": "צפייה בראיונות קודמים",
        "BenefitsBox_Point2": "קבלת משוב על ראיונות קודמים",
        "BenefitsBox_Point3": "שימוש בתשובות הקודמות גם בראיונות חדשים",
        "BenefitsBox_Point4": "לקבל עצות לראיונות",
        "BenefitsBox_Point5": "לקרוא מדריכי קריירה",
        "BenefitsBox_Point6": "ועוד הרבה",
        "Label_FirstName": "שם פרטי",
        "Label_LastName": "שם משפחה",
        "Label_Email": "אימייל",
        "Label_Password": "סיסמה",
        "Label_PhoneNumber": "מספר טלפון",
        "Label_TermsOfService": "אישור",
        "Label_TermsOfServiceLink": "מדיניות הפרטיות ותנאי השימוש",
        "Placeholder_CountryCode": "בחירת קידומת מדינה",
        "Placeholder_PhoneNumber": "לדוגמה 0501234567",
        "HelpText_Password": "הסיסמה צריכה להכיל לפחות 6 תווים.",
        "ButtonText_SignUp": "הרשמה",
        "ButtonText_SignUpWithGoogle": "הרשמה עם Google",
        "OrSeparator": "או",
        "Error_FirstName_Required": "יש להזין שם פרטי.",
        "Error_LastName_Required": "יש להזין שם משפחה.",
        "Error_Email_Required": "יש להזין אימייל.",
        "Error_Email_Invalid": "יש להזין כתובת אימייל תקינה.",
        "Error_Email_Exists": "כתובת האימייל כבר בשימוש.",
        "Error_Password_Required": "יש להזין סיסמה.",
        "Error_Password_6_Characters": "הסיסמה שלך חייבת להכיל לפחות 6 תווים.",
        "Error_PhoneNumber_Required": "יש להזין מספר טלפון.",
        "Error_PhoneNumber_Invalid": "מספר הטלפון אינו תקין.",
        "Error_PrivacyPolicyCheck_Required": "יש לאשר את מדיניות הפרטיות ותנאי השימוש."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "לפני שמתחילים את הראיון, יש לאשר את תנאי השימוש של Hubert. פשוט מסמנים את התיבה וממשיכים..",
        "Subtitle_AfterInterviewCompleted": "אפשר להירשם כדי לראות תוצאות, לקבל משוב, לקרוא עצות ועוד.",
        "PrivacyPolicyText": "בלחיצה על „הרשמה” ניתנת הסכמה ל",
        "PrivacyPolicyLink": "מדיניות הפרטיות ותנאי השימוש",
        "ButtonText_SignUp": "הרשמה ומעבר לראיון",
        "ButtonText_SignUpNormal": "הרשמה",
        "ButtonText_SignInInstead": "התחברות במקום זאת"
    },
    "LoginInviteEmail": {
        "Subtitle": "אפשר להתחבר כדי לראות תוצאות, לקבל משוב, לקרוא עצות ועוד."
    },
    "AppMessages": {
        "internal-server-error": "אירעה שגיאה לא צפויה.",
        "invalid-credentials": "פרטי ההתחברות שגויים. אפשר לנסות שוב.",
        "user-not-found": "פרטי ההתחברות שגויים. אפשר לנסות שוב.",
        "account-not-found": "החשבון אינו תקין. אפשר לנסות שוב.",
        "verify-email-title": "אימות האימייל שלך",
        "verify-email-subtitle": " יש לבדוק את האימייל כדי לאמת את החשבון.",
        "email-not-verified-title": "האימייל לא אומת",
        "email-not-verified-subtitle": "יש לבדוק את האימייל כדי לאמת את החשבון.",
        "verifying-email-title": "מאמתים את האימייל",
        "verifying-email-subtitle": "אנא המתינו...",
        "sign-in-title": "מתחברים",
        "sign-in-subtitle": "אנא המתינו...",
        "server-error": "משהו השתבש.",
        "hubert-user-exists": "החשבון כבר קיים.",
        "account-exists": "החשבון כבר קיים.",
        "email-verified": "האימייל שלך אומת.",
        "email-is-taken": "כתובת האימייל כבר בשימוש.",
        "re-enter-password": "להתחברות, יש להשתמש בסיסמה.",
        "password-reset": "הסיסמה שלך שונתה.",
        "re-enter-new-password": "להתחברות, יש להשתמש בסיסמה החדשה.",
        "invalid-invitation": "ההזמנה אינה תקינה.",
        "invalid-code": "קוד האימות אינו תקין.",
        "email-already-verified": "האימייל כבר אומת.",
        "email-mismatch-title": "אי-התאמה באימייל",
        "email-mismatch-subtitle": "יש להשתמש באותה כתובת אימייל ששימשה להגשת המועמדות."
    },
    "TransitionPage": {
        "loading-title": "טוען...",
        "loading-subtitle": "מכינים את הנתונים שלך...",
        "logout-title": "טוען...",
        "logout-subtitle": "מתנתקים..."
    },
    "ImpersonationPage": {
        "loading-title": "טוען...",
        "loading-subtitle": "מכינים את הנתונים שלך..."
    },
    "ProcessInvitation": {
        "loading-title": "טוען...",
        "loading-subtitle": "רק רגע, הראיון בטעינה.",
        "InvitationNotFound": "לא מצאנו את הראיון שלך.",
        "InvitationExpired": "הקישור לראיון פג תוקף.",
        "InvitationExpired_Description1": "יש לפתוח את הראיון דרך",
        "InvitationExpired_Description2": "או לפנות לצוות הגיוס.",
        "InvitationInvalid": "הקישור להזמנה זו אינו תקין.",
        "InterviewCompleted": "הראיון הזה כבר הושלם."
    },
    "Common": {
        "MyInterviews": {
            "Title": "הראיונות שלי",
            "TableHead_Employer": "מעסיק",
            "TableHead_Job": "משרה",
            "TableHead_Status": "סטטוס",
            "TableHead_ApplicationDate": "תאריך הגשה",
            "TableBody_StartInterview": "הראיון עדיין לא הושלם. אפשר להתחיל אותו או להמשיך מהמקום שבו הופסק, כאן.",
            "TableBody_NotScored": "הראיון הושלם. התוצאות יהיו זמינות בקרוב.",
            "TableBody_Details": "לצפייה בתוצאות הראיון ובמידע נוסף.",
            "ApplicationDate_Invited": "התקבלה הזמנה",
            "ApplicationDate_MinuteAgo": "דקה",
            "ApplicationDate_MinutesAgo": "דקות",
            "ApplicationDate_HourAgo": "שעה",
            "ApplicationDate_HoursAgo": "שעות",
            "ApplicationDate_DayAgo": "יום",
            "ApplicationDate_DaysAgo": "ימים",
            "ButtonText_SeeAllInterviews": "כל הראיונות",
            "ButtonText_Details": "פרטים",
            "ButtonText_StartInterview": "לראיון",
            "ButtonText_NotScored": "ממתין לתוצאות",
            "NoInterviews_Message": "אין ראיונות קודמים או ראיונות קרובים."
        },
        "LatestJobPostings": {
            "NoJobPostings": "אין משרות פתוחות כרגע. כדאי לבדוק שוב מאוחר יותר."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "הקריירה שלי",
            "Subtitle": "בחירת ראיון תציג את הערכת ההתאמה ואת הסיכויים שלך.",
            "MostRecentInterview": "הראיון האחרון",
            "ToDo": "לביצוע",
            "NoOngoingInterviews_Title": "עדיין אין הזמנות חדשות לראיון.",
            "NoOngoingInterviews_Subtitle": "ראיונות Hubert חדשים יופיעו כאן כשהמגייסים יקבעו אותם .",
            "NoRecentInterviews_Title": "לא נמצאו ראיונות קודמים.",
            "NoRecentInterviews_Subtitle": "לאחר קבלת הזמנה לראיון, הוא יופיע כאן למטה.",
            "ButtonText_StartInterview": "לראיון",
            "ButtonText_NotScored": "ממתין לתוצאות",
            "ButtonText_Details": "פרטים"
        },
        "LearnWithHubert": {
            "Title": "למידה עם Hubert",
            "Subtitle": "עצות לשיפור כישורי הראיון והביצועים בעבודה.",
            "PickedForMe": "מאמרים אחרונים",
            "ButtonText_SeeAllArticles": "כל המאמרים"
        },
        "HubertTip": {
            "Title": "טיפ מ-Hubert",
            "Subtitle": "לסיים ראיונות מהר יותר",
            "Description": "הגשת מועמדות למשרה דומה שכבר התקיים בה ראיון Hubert? אפשר להשתמש שוב בתשובות מהראיון הקודם ולחסוך זמן.",
            "ButtonText_ReadMoreTips": "עוד טיפים"
        },
        "NewCandidateModalPopup": {
            "Title": "הכול מוכן!",
            "DescriptionLine1": "החשבון שלך מוכן.",
            "DescriptionLine2": "אפשר לנהל את הראיונות ואת הפרופיל, לצפות בתוצאות, לקבל משוב וללמוד עוד על ראיונות.",
            "ButtonText_LetsGo": "קדימה"
        },
        "InterviewCompletedModal": {
            "Title": "עבודה מצוינת!",
            "Subtitle": "סיימת את הראיון.",
            "Description": "המגייסים יעברו על כל המועמדויות וישלחו משוב באימייל או בטלפון ברגע שיהיה עדכון.",
            "ButtonText_Continue": "המשך"
        },
        "LatestJobPostings": {
            "Title": "משרות אחרונות",
            "Subtitle": " Hubert משרות שהתפרסמו לאחרונה בחברות שמגייסות דרך."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "הראיונות שלי",
        "MyInterviewsSection_Subtitle": "בחירת ראיון תציג את הערכת ההתאמה ואת הזדמנויות הקריירה שלך.",
        "MyInterviewsSection_ToDo": "לביצוע"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "כל הראיונות",
        "InterviewNotFound_Title": "הראיון אינו נגיש",
        "InterviewNotFound_Description": "לא ניתן לגשת לפרטי ראיון שאינם משויכים לחשבון.",
        "ButtonText_GoToAllInterviews": "לראיונות שלי",
        "InterviewDetails": {
            "Title": "פרטי הראיון",
            "ForRole": "לתפקיד",
            "InterviewCompletedOn": "הראיון הושלם ב-{{date}} בשעה {{time}}"
        },
        "MyResult": {
            "Title": "התוצאה שלי",
            "Subtitle": "התאמה מוערכת",
            "ButtonText_LearnMore": "כך מתבצעת הערכת התשובות",
            "GotPotential_Title": "נראה שיש התאמה טובה, אך עדיין חסרה דרישה אחת.",
            "GotPotential_Description": "התשובות מצביעות על התאמה טובה לתפקידים מהסוג הזה. עם זאת, ייתכן שחלק מדרישות המשרה הספציפית עדיין לא מתקיימות. הדבר עשוי להשפיע על המשך התהליך, בהתאם לצורכי המגייס ולמועמדים האחרים, גם אם לא תישלח הזמנה לשלב הבא, אין בכך כדי להעיד על היכולות המקצועיות. לפעמים פשוט מדובר בהתאמה מדויקת יותר לצרכים של תפקיד מסוים. בהמשך מופיעים תפקידים נוספים וטיפים שיכולים לעזור בהמשך הדרך.",
            "GotPotential_DescriptionSecondary": "חשוב לדעת: ההערכה של Hubert היא המלצה בלבד. ההחלטה הסופית מתקבלת על ידי המגייס, וגורמים נוספים, כגון מספר המועמדים, עשויים להשפיע על התוצאה.",
            "GreatMatch_Title": "התאמה חזקה",
            "GreatMatch_Description": "התשובות מתאימות היטב למה שבדרך כלל מחפשים בתפקיד הזה, ועומדות בדרישות המשרה. עבודה מצוינת! המגייס יעבור על כל המועמדויות ויחליט על הצעדים הבאים.",
            "GreatMatch_DescriptionSecondary": "שוב לדעת: ההערכה של: Hubert היא המלצה בלבד. ההחלטה הסופית מתקבלת על ידי המגייס, וגם גורמים נוספים, כמו מספר המועמדים, עשויים להשפיע על התוצאה. אם לא תתקבל הזמנה לשלב הבא, אין בכך כדי להעיד על היכולות או הניסיון המקצועי. לפעמים מדובר פשוט בהתאמה לצרכים הספציפיים של התפקיד. בהמשך אפשר למצוא משרות נוספות וטיפים לשיפור.",
            "OkMatch_Title": "התאמה טובה, עם מקום לשיפור",
            "OkMatch_Description": "התשובות עומדות בדרישות המשרה. כדי לחזק את הרושם, כדאי להוסיף יותר בהירות ודוגמאות קונקרטיות. בהמשך אפשר לראות איך דוגמאות מהניסיון ותוצאות ברורות יכולות לחזק את התשובות.",
            "OkMatch_DescriptionSecondary": "לתשומת לבכם: ההערכה של Hubert היא המלצה. המגייס מקבל את ההחלטה הסופית, וגורמים נוספים, כמו מספר המועמדים, יכולים גם להשפיע על התוצאה.",
            "NotClearMatch_Title": "יכול להיות שהמשרה הזו פחות מתאימה",
            "NotClearMatch_Description": "על סמך הראיון הזה, התשובות פחות תואמות למה שהמגייס מחפש בתפקיד הזה, או שייתכן שדרישה אחת או יותר עדיין אינן מתקיימות. לשיפור, כדאי להתחיל מהשאלות שבהמשך. שינויים קטנים, פירוט נוסף ותוצאות ברורות יכולים לעשות הבדל משמעותי בפעם הבאה.",
            "NotClearMatch_DescriptionSecondary": "לתשומת לבכם: ההערכה של Hubert היא המלצה. המגייס מקבל את ההחלטה הסופית, וגורמים נוספים, כמו מספר המועמדים, יכולים גם להשפיע על התוצאה."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "ניסיון מקצועי, מוטיבציה וכישורים",
            "QualifyingRequirements": "דרישות סף למשרה הספציפית הזו",
            "NotQualified_Title": "יש מקום לשיפור",
            "NotQualified_Description": "התשובות היו פחות ממוקדות ופחות ספציפיות ממה שבדרך כלל מחפשים בתפקיד הזה. בהמשך אפשר לראות איפה דוגמה קונקרטית, פעולה ברורה או תוצאה מדידה יכולות לחזק את התשובות.",
            "GreatResults_Title": "תשובות חזקות",
            "GreatResults_Description": "התשובות מצביעות על התאמה לתפקידים מהסוג הזה ועל הצגה ברורה של הניסיון. שאלות שאפשר לשפר מסומנות בהמשך.",
            "MeetingRequirements_Title": "עמידה בדרישות",
            "MeetingRequirements_Description": "התשובות מצביעות על עמידה בדרישות הסף שהוגדרו למשרה הזו. זהו בסיס טוב.",
            "NotAllExpectationsMet_Title": "חסרה דרישה אחת או יותר",
            "NotAllExpectationsMet_Description": "על סמך התשובות, ייתכן שדרישת סף אחת או יותר של המשרה הזו עדיין לא מתקיימת, למשל דרישה לתעודה, רישיון, רמת השכלה או מספר שנות ניסיון.",
            "ButtonText_FindOutPossibleReasons": "צפייה בפרטים"
        },
        "ScriptFromInterview": {
            "Title": "תמליל הראיון המלא",
            "ButtonText_SeeWholeTranscript": "לקריאת הראיון המלא",
            "ButtonText_DeleteInterview": "מחיקת הראיון",
            "Loading_Title": "טוען...",
            "Loading_Subtitle": "אנא המתינו בזמן שאנחנו טוענים את תמליל הראיון שלך."
        },
        "HowToImproveAtInterviews": {
            "Title": "איך להשתפר בראיונות",
            "Subtitle_Questions": "הנה כמה שאלות שבהן התשובה שלך יכולה להשתפר.",
            "Subtitle_NoQuestions": "לא נבחרו תשובות ספציפיות. בהמשך אפשר למצוא כמה דרכים שיעזרו לחזק את התשובות ולהשאיר רושם טוב יותר בתפקיד הזה.",
            "GreatMatch_Questions_Description": "גם כשיש תשובות טובות, תמיד אפשר לחזק חלק מהן. אם זיהינו תשובות כאלה, הן מופיעות בהמשך. כדאי לעקוב אחר ההנחיות לפני כל שאלה. כשמתארים מצב, מומלץ להסביר מה קרה, מה נעשה ומה הייתה התוצאה. תשובה כמו „OK” לא עוזרת כשמבקשים להרחיב, אבל גם אין צורך להאריך יותר מדי. כדאי להתמקד בתשובות ברורות ומוחשיות, כמו בראיון פנים אל פנים.",
            "GreatMatch_NoQuestions_Description": "התשובות עמדו בציפיות לתפקיד. עבודה מצוינת.",
            "OkMatch_Questions_Description": "בהמשך אפשר לראות שאלות שבהן כדאי לחזק את התשובות. כדאי לעקוב אחר ההנחיות לפני כל שאלה. כשמתארים מצב, מומלץ להסביר מה קרה, מה נעשה ומה הייתה התוצאה. תשובה כמו „OK” לא עוזרת כשמבקשים להרחיב, אבל גם אין צורך להאריך יותר מדי. כדאי להתמקד בתשובות ברורות ומוחשיות, כמו בראיון פנים אל פנים.",
            "OkMatch_NoQuestions_Description": "התשובות שלך היו טובות, אבל התפקיד הזה עשוי להיות תחרותי. זה אומר שגם תשובות טובות יכולות להישאר באמצע הדירוג.",
            "OkMatch_NoQuestions_DescriptionSecondary": "בפעם הבאה כדאי להתמקד בתוצאה ובמה שהושג. דוגמה אמיתית אחת יכולה לעזור להמחיש את זה, וכדאי לשמור על תשובה קצרה וממוקדת, בדרך כלל 3 עד 6 משפטים.",
            "GotPotential_Questions_Description": "גם כשיש התאמה טובה לתפקיד, חלק מהתשובות עדיין יכולות להשתפר. אם זיהינו תשובות כאלה, הן יופיעו בהמשך. כדאי לעקוב אחר ההנחיות שלפני כל שאלה. כשמתארים מצב, מומלץ להסביר מה קרה, מה נעשה בעניין ומה הייתה התוצאה. תשובה כמו „OK” לא מספיקה כשמבקשים להרחיב. עם זאת, אין צורך בתשובות ארוכות מדי. כדאי לשמור על תיאורים ברורים ומוחשיים, כמו בראיון פנים אל פנים.",
            "GotPotential_NoQuestions_Description": "לא מצאנו תשובות שדורשות שיפור משמעותי בנוגע לכישורים מקצועיים ולמוטיבציה. נראה שענית היטב בנושאים האלה.",
            "NotClearMatch_Questions_Description": "למטה ישנן שאלות שבהן כדאי לחזק את התשובות. כדאי לעקוב אחר ההנחיות לפני כל שאלה. כשמתארים מצב, מומלץ להסביר מה קרה, מה עשית ומה הייתה התוצאה. תשובה כמו „OK” לא מספיקה כשמבקשים להרחיב. עם זאת, אין צורך בתשובות ארוכות מדי. כדאי להתמקד בתשובות ברורות ומוחשיות, כמו בראיון פנים אל פנים.",
            "NotClearMatch_NoQuestions_Description": "לא הייתה תשובה ספציפית אחת שהשפיעה על ההערכה. ההחלטה תלויה במידה שבה התשובות מתאימות לצורכי התפקיד, ובמקרים שבהם יש תחרות רבה, גם פערים קטנים יכולים להשפיע על התוצאה.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "בראיון הבא, כדאי להתמקד בדוגמאות מוחשיות. לכל שאלה, מומלץ לבחור דוגמה אחת, להסביר אילו פעולות נעשו ולשתף בתוצאה. לרוב, ניסוח קצר וספציפי עדיף על ניסוח ארוך וכללי.",
            "Alert_WantMoreAdvice": "רוצה עוד עצות איך להצליח בראיון Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "ניתן לעיין במאמר העצות הכללי שלנו"
        },
        "SimilarOffers": {
            "Title": "הצעות דומות"
        },
        "HowHubertScoresInterviews": {
            "Title": "איך Hubert מעריך ראיונות?",
            "Description": "בהמשך ניתן לקרוא בקצרה איך Hubert בוחן את התשובות בראיון ומה עשויים להיות השלבים הבאים בתהליך הגיוס לאחר הראיון.",
            "Tabs_PossibleOutcomes": "תוצאות אפשריות",
            "Tabs_RecruitmentProcess": "תהליך הגיוס",
            "AssessedMatch_Title": "מידת ההתאמה",
            "AssessedMatch_Description":"Hubert בוחן את התשובות כמכלול, בהתאם למה שמגייסים מחפשים בדרך כלל בתפקיד הזה. יחד עם דרישות התפקיד, ההערכה הזו מובילה לאחת מהתוצאות שמפורטות בהמשך.",
            "AssessedMatch_DescriptionSecondary": "לתשומת לבכם: ההערכה של Hubert היא המלצה. המגייס מקבל את ההחלטה הסופית, וגורמים נוספים, כמו מספר המועמדים, יכולים גם להשפיע על התוצאה.",
            "GreatMatch_Title": "מידת התאמה גבוהה",
            "GreatMatch_Description": "התשובות התאימו היטב למה שמגייסים מחפשים בדרך כלל בתפקיד הזה, והן עומדות בדרישות המשרה. עבודה מצוינת. המגייס יעבור על כלל המועמדים ויחליט על הצעדים הבאים.",
            "GotPotential_Title": "מתאים במידה רבה, אך דרישה אחת עדיין חסרה",
            "GotPotential_Description": "התשובות מצביעות על התאמה טובה לתפקידים מהסוג הזה. עם זאת, ייתכן שדרישה אחת או יותר של המשרה הספציפית עדיין לא מתקיימת. הדבר עשוי להשפיע על המשך התהליך, בהתאם לצורכי המגייס ולמספר המועמדים.",
            "OkMatch_Title": "עמידה בדרישות, עם מקום לשיפור",
            "OkMatch_Description": "התשובות עומדות בדרישות המשרה. כדי לחזק את הרושם, כדאי להיות ברורים ומדויקים יותר ולתת דוגמאות שמראות מה עשית ומה השגת. המשוב מהראיון יכול לעזור לזהות מקומות שבהם דוגמאות ותוצאות ברורות יכולות לחזק את התשובות.",
            "NotClearMatch_Title": "ייתכן שזו עדיין לא ההתאמה הנכונה",
            "NotClearMatch_Description":"על סמך הראיון הזה, התשובות פחות תואמות למה שהמגייס מחפש בתפקיד הזה, וייתכן שדרישה אחת או יותר עדיין לא מתקיימת. בהמשך אפשר לראות איפה כדאי להוסיף יותר פירוט, דוגמאות ותוצאות כדי לחזק את התשובות.",
            "ProfessionalExperiences_Title": "ניסיון מקצועי, מוטיבציה וכישורים",
            "ProfessionalExperiences_Description": "אלה שאלות על הניסיון הקודם שלך, המוטיבציה שלך למשרה, והכישורים הרלוונטיים לתפקיד. המגייסים מחליטים אילו שאלות ייכללו בראיון למשרה הספציפית.",
            "GreatResults_Title": "תשובות טובות",
            "GreatResults_Description": "התשובות מצביעות על התאמה לתפקידים מהסוג הזה ועל הצגה ברורה של הניסיון. שאלות שאפשר לשפר יסומנו בראיון.",
            "NotQualified_Title": "אפשר לחזק כמה נקודות",
            "NotQualified_Description": "התשובות היו פחות ספציפיות או פחות ממוקדות בתוצאה מכפי שמצופה בתפקיד הזה. המקומות המסומנים מציגים היכן דוגמה מוחשית, פעולות שננקטו או תוצאה ברורה יכולים לחזק את התשובות.",
            "QualifyingRequirements_Title": "דרישות בסיס או דרישות סף למשרה הספציפית הזו",
            "QualifyingRequirements_Description": "אלה שאלות שהמגייס הגדיר כדרישות סף למשרה. לדוגמה תעודה נדרשת, רישיון נהיגה, או רמת ניסיון רלוונטי מסוימת.",
            "MeetingRequirements_Title": "עמידה בדרישות",
            "MeetingRequirements_Description": "התשובות מצביעות על עמידה בדרישות הסף שהמגייס הגדיר למשרה הזו. זהו בסיס טוב.",
            "NotAllExpectationsMet_Title": "חסרה דרישה אחת או יותר",
            "NotAllExpectationsMet_Description": "על סמך התשובות, ייתכן שדרישת סף אחת או יותר למשרה הספציפית הזו אינן מתקיימות, כמו תעודות, רישיונות, רמת השכלה או שנות ניסיון.",
            "RecruitmentProcess_Title": "תהליך הגיוס",
            "RecruitmentProcess_Description": "Hubert משמש בדרך כלל כשלב הראשון בתהליך גיוס עם מועמדים רבים. זה מאפשר לכולם לעבור ראיון ולשתף יותר על עצמם במילים שלהם. מכיוון ששאלות הראיון זהות לכל המועמדים לאותה משרה, התהליך עקבי יותר. Hubert גם לא משתמש במידע כמו גיל, מגדר, מוצא אתני, דת או מראה, מה שעוזר להפחית את הסיכון להטיה לא מודעת.",
            "EventOne_Title": "ישנו ראיון עם Hubert",
            "EventOne_Description": "אפשר לעבור את הראיון עם Hubert בכל זמן ומקום שנוח. אין הגבלת זמן, ואפשר לקחת הפסקה בכל רגע ולהמשיך מהנקודה שבה הופסק הראיון.",
            "EventTwo_Title": "הראיון שלך נמצא כעת בבדיקה",
            "EventTwo_Description": "Hubert בוחן את התשובות באמצעות טכנולוגיה מתקדמת. לאחר סיום ההערכה, התוצאות יהיו זמינות כאן ב־My Hubert וגם למגייס במערכת המועמדויות.",
            "EventThree_Title": "המגייס בוחר מועמדים לשלבים הבאים",
            "EventThree_Description": "במערכת המועמדויות, המגייסים יכולים לראות כשתוצאות ראיון חדש של Hubert זמינות ולעבור על התשובות ועל ההערכה. על סמך ההערכה של Hubert ושיקול הדעת שלהם, הם מחליטים אם להזמין לשלב הבא. זה יכול להיות שיחת טלפון, מבחן או ראיון סופי. לפעמים המגייסים יעדיפו להמתין לפני שימשיכו בתהליך. אם מועמדים אחרים מתאימים יותר לצורכי התפקיד, ייתכן שהמועמדות לא תמשיך לשלב הבא.",
            "ButtonText_Close": "סגירה"
        }
    },
    "MyProfile": {
        "Title": "הפרופיל שלי",
        "MyDetails": {
            "Title": "הפרטים שלי",
            "Label_FirstName": "שם פרטי",
            "Label_LastName": "שם משפחה",
            "Label_Email": "אימייל",
            "Label_PhoneNumber": "מספר טלפון",
            "ButtonText_UpdateDetails": "עדכון פרטים",
            "Error_FirstName_Required": "יש להזין שם פרטי.",
            "Error_LastName_Required": "יש להזין שם משפחה.",
            "Error_Email_Required": "יש להזין אימייל.",
            "Error_Email_Invalid": "יש להזין כתובת אימייל תקינה.",
            "Error_PhoneNumber_Invalid": "מספר הטלפון אינו תקין.",
            "Success_Details_Updated": "הפרופיל עודכן."
        },
        "ChangePassword": {
            "Title": "שינוי סיסמה",
            "Set_Password_Title": "יצירת סיסמה",
            "Label_CurrentPassword": "סיסמה נוכחית",
            "Label_NewPassword": "סיסמה חדשה",
            "Label_RepeatNewPassword": "חזרה על הסיסמה החדשה",
            "Alert_SignInAgain": "יש להתחבר מחדש כדי להגדיר סיסמה.",
            "ButtonText_UpdatePassword": "עדכון סיסמה",
            "ButtonText_SetPassword": "הגדרת סיסמה",
            "ButtonText_SignInAgain": "התחברות מחדש",
            "Error_CurrentPassword_Required": "יש להזין את הסיסמה הנוכחית.",
            "Error_CurrentPassword_DoesntMatch": "הסיסמה אינה תואמת לסיסמה הנוכחית.",
            "Error_NewPassword_Required": "יש להזין סיסמה חדשה.",
            "Error_NewPassword_6_Characters": "הסיסמה החדשה חייבת להכיל לפחות 6 תווים.",
            "Error_RepeatNewPassword_Required": "יש לחזור על הסיסמה החדשה.",
            "Error_RepeatNewPassword_DoesntMatch": "הסיסמה אינה תואמת לסיסמה החדשה.",
            "Success_Password_Changed": "הסיסמה עודכנה.",
            "Error_Invalid_CurrentPassword": "הסיסמה הנוכחית שגויה."
        },
        "NotificationPreferences": {
            "Title": "העדפות התראות",
            "Label_ReceiveUpdatesToggle": "אני רוצה לקבל עדכונים מ-Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "יישלחו תכנים שימושיים, טיפים לראיונות ועוד."
        },
        "AccountRemoval": {
            "Title": "הסרת חשבון",
            "ButtonText_RemoveMyAccount": "הסרת החשבון שלי"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "שלום",
        "Subtitle": "ראיון העבודה עומד להתחיל.",
        "TipBox_Title": "הנה כמה טיפים שיעזרו לך להצליח.",
        "TipBox_Tip1": "מומלץ לעבור את הראיון במקום שקט, שבו אפשר להתרכז ולכתוב בנוחות.",
        "TipBox_Tip2": "מומלץ לענות מהמחשב באמצעות מקלדת, אלא אם נוח לך לכתוב תשובות ארוכות בטלפון.",
        "TipBox_Tip3": "כדאי לתת תשובות ספציפיות ומפורטות ככל האפשר. Hubert והמגייסים רוצים להכיר את הניסיון ואת הכישורים היטב.",
        "TipBox_Tip4": "אפשר לקחת את הזמן הדרוש. אין הגבלת זמן לראיון.",
        "TipBox_Tip5": "אפשר לקחת הפסקה בכל רגע ולהמשיך מהנקודה שבה הופסק הראיון.",
        "TipBox_Tip6": "כדאי להתייחס לראיון עם Hubert ברצינות, בדיוק כמו לראיון עם מראיין אנושי.",
        "CheckAdviceArticle_Text1": "לטיפים נוספים להצלחה בראיון, כדאי לעיין ב־",
        "CheckAdviceArticle_Text2": "מאמר",
        "CheckAdviceArticle_Text3": "עם עצות טובות.",
        "ReadyToGetStarted": "אפשר להתחיל?",
        "ORSeparator_Text": "או",
        "ButtonText_StartInterviewNow": "להתחיל את הראיון עכשיו",
        "ButtonText_SetReminder": "לא מתאים כרגע? שלחו לי תזכורת",
        "PrivacyPolicyText": "בלחיצה על „התחלת הראיון” ניתנת הסכמה ל",
        "PrivacyPolicyLink": "מדיניות הפרטיות ותנאי השימוש"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "עבודה מצוינת!",
        "CompletedAlert_Subtitle": "סיימת את הראיון.",
        "CompletedAlert_Description": "המגייסים יעברו על כל המועמדויות וישלחו משוב באימייל או בטלפון ברגע שיהיה עדכון.",
        "InterviewNotCompleted": "הראיון הזה לא הושלם."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "מרכז העזרה",
            "Subtitle": "ניתן למצוא תשובות לשאלות הנפוצות ביותר על Hubert.",
            "Label_Search": "חיפוש בשאלות נפוצות",
            "ButtonText_Search": "חיפוש"
        },
        "FAQSection": {
            "Tabs_All": "הכול",
            "Tabs_AboutHubertInterview": "על ראיון Hubert",
            "Tabs_TechnicalSupport": "תמיכה טכנית"
        },
        "StillHaveQuestion": {
            "Title": "עדיין יש שאלה?",
            "Description": "נשמח לעזור.",
            "DropUsAEmail": "אפשר לפנות אלינו באימייל: hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "האם אפשר לעבור את הראיון בשיחת טלפון במקום?",
                    "a": "Hubert פועל כרגע בצ׳אט בלבד. אם יש לך מצב רפואי שמקשה עליך להשתתף בראיון, כדאי לפנות ישירות לחברה המגייסת. Hubert מטפל רק בראיון הצ׳אט."
                },
                {
                    "q": "האם אפשר לעבור את הראיון בשפה אחרת?",
                    "a": "בחלק מהראיונות יש אפשרות לבחור שפה בתחילת הראיון. אם האפשרות חסרה, הבנת השפה בראיון היא כנראה דרישה לתפקיד. לשאלות נוספות, יש לפנות לחברה המגייסת."
                },
                {
                    "q": "האם אקבל ציון נמוך על תשובות קצרות?",
                    "a": "לא, כל עוד המענה על השאלות באופן הולם. אין אורך מינימלי לתשובה, אבל פירוט לרוב עוזר."
                },
                {
                    "q": "האם אפשר לעשות שימוש חוזר בתשובות מראיון אחר עם Hubert?",
                    "a": "כן, אפשר להשתמש שוב בתשובות קודמות לאחר התחברות ל־My Hubert והגשת מועמדות לתפקיד דומה."
                },
                {
                    "q": "האם אדם יקרא את הראיון שלי?",
                    "a": "כן, הלקוחות שלנו מתבקשים לבדוק ראיונות באופן ידני."
                },
                {
                    "q": "עשיתי את הראיון, מה קורה עכשיו?",
                    "a": "לאחר סיום הראיון, התוצאות נשלחות למגייס במערכת המועמדויות שלו. המגייסים יכולים לעבור על התשובות שלך ועל ההערכה של Hubert. על סמך ההערכה המייעצת של Hubert ועל שיקול דעתם, המגייסים מחליטים אם תעבור לשלב הבא. זה יכול להיות שיחת טלפון, מבחן או ראיון סופי."
                },
                {
                    "q": "יש לי שאלה על השלבים הבאים בתהליך, למי לפנות?",
                    "a": "יש לפנות לחברה שאליה הגשת מועמדות."
                },
                {
                    "q": "איך אתם מוודאים שאין הטיה בתהליך הגיוס?",
                    "a": "הפחתת הטיה חשובה לנו מאוד. כמכונה, Hubert עקבי יותר בהערכה מאדם. המודלים שלנו מאומנים על ידי מומחים מרקעים מגוונים. בנוסף, Hubert לא משתמש במידע כמו מגדר, גיל, מוצא אתני, דת או מראה, שהם מקורות נפוצים להטיה בראיונות עבודה ידניים."
                },
                {
                    "q": "האם אפשר לעבור ראיון עם אדם במקום Hubert?",
                    "a": "יש לפנות לחברה שאליה הגשת מועמדות כדי לברר על כך."
                },
                {
                    "q": "האם Hubert הוא אדם?",
                    "a": "לא, Hubert הוא מערכת ממוחשבת לראיונות ולניתוח."
                },
                {
                    "q": "האם אפשר לשנות את התשובות אחר כך?",
                    "a": "לא, כמו בראיון אמיתי, אי אפשר לשנות תשובות אחרי שנשלחו."
                },
                {
                    "q": "איך מצליחים בראיון Hubert?",
                    "a": "כדאי לקרוא את השאלות בעיון לפני שעונים, לעקוב אחר ההנחיות, לתת דוגמאות אמיתיות מהניסיון ולענות בכנות."
                },
                {
                    "q": "אני בתהליך של חיפוש עבודה, למי לפנות?",
                    "a": "יש לפנות לחברה שאליה הגשת מועמדות."
                },
                {
                    "q": "עשיתי את הראיון ועדיין לא שמעתי כלום. מה לעשות?",
                    "a": "המגייסים מחליטים על הצעדים הבאים על סמך ההערכה של Hubert ועל שיקול דעתם. זה יכול להיות שיחת טלפון, מבחן או ראיון סופי. אם מועמדים אחרים מתאימים יותר, המועמדות עשויה להידחות. אפשר לפנות למגייס כדי לבדוק את מצב המועמדות."
                },
                {
                    "q": "יש לי הרבה ניסיון, אבל לא קיבלתי את המשרה. למה?",
                    "a": "התחרות על משרות יכולה להיות גבוהה, עם מועמדים מתאימים רבים. אם המועמדות נדחתה, אפשר לפנות לחברה ולשאול מדוע. אפשר גם לבדוק ב־My Hubert משוב על סמך התשובות ולראות משרות אחרות."
                },
                {
                    "q": "כמה זמן אורך הראיון?",
                    "a": "זה תלוי במספר השאלות שהמגייס הגדיר. משך הראיון הצפוי הוא 10 עד 25 דקות. אין צורך למהר, ואפשר לקחת הפסקה ולהמשיך אחר כך במקרה הצורך."
                },
                {
                    "q": "איפה אפשר לקרוא איך הנתונים שלי מטופלים?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "למה אני לא רואה את ראיונות Hubert הקודמים שלי?",
                    "a": "יש לוודא שנעשה שימוש באותה כתובת אימייל בהגשת המועמדות ובהתחברות ל־My Hubert. הדבר חל גם על התחברות עם Google: כתובת האימייל של Google חייבת להתאים לכתובת שבהגשה. אפשר ליצור חשבון באמצעות כתובת האימייל ששימשה להגשת המועמדות."
                },
                {
                    "q": "למה לא קיבלתי אימייל לראיון שלי?",
                    "a": "יש לבדוק את תיקיית הספאם. אפשר גם להוסיף את hubert@hubert.ai לאנשי הקשר. לחלופין, אפשר ליצור חשבון My Hubert באמצעות כתובת האימייל ששימשה להגשת המועמדות כדי למצוא שם את קישור הראיון."
                },
                {
                    "q": "איך מוצאים את קישור הראיון באימייל?",
                    "a": "יש לבדוק את תיקיית הספאם. לחלופין, אפשר ליצור חשבון My Hubert באמצעות כתובת האימייל ששימשה להגשה ולעבור אל „הראיונות שלי” כדי למצוא את הקישור."
                },
                {
                    "q": "האם הראיון עובד במכשירים ניידים?",
                    "a": "כן. עם זאת, אם נוח לך יותר להקליד במחשב, אנחנו ממליצים על כך."
                },
                {
                    "q": "הראיון לא עובד, מה לעשות?",
                    "a": "מצטערים לשמוע. אפשר לפנות אלינו באימייל: hubert@hubert.ai, ונשמח לעזור."
                },
                {
                    "q": "אני רוצה למחוק את כל החשבון ב-My Hubert, מה לעשות?",
                    "a": "אפשר לפנות אלינו באימייל: hubert@hubert.ai, ונשמח לעזור."
                },
                {
                    "q": "הראיון הופסק — איך ממשיכים?",
                    "a": "יש ללחוץ על הקישור בהזמנה באימייל כדי לחזור לנקודה שבה הופסק הראיון, או להתחבר ל־My Hubert ולבחור את הראיון ב„הראיונות שלי”."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "למידה עם Hubert",
            "Subtitle": "איך להגדיל את הסיכויים בתהליך הגיוס ולהצליח יותר בעבודה.",
            "Label_Search": "חיפוש במדריכי ראיונות וקריירה",
            "ButtonText_Search": "חיפוש"
        },
        "TabSelector": {
            "MyFeed": "הפיד שלי",
            "InterviewGuides": "איך להתכונן לראיון",
            "CareerGuides": "משאבים לחיפוש עבודה"
        },
        "NewestOnTheFeed": "תוכן חדש",
        "PickedForMe": "מאמרים אחרונים",
        "InterviewGuides": "איך להתכונן לראיון",
        "CareerGuides": "משאבים לחיפוש עבודה"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "חזרה לכל המאמרים"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "איפוס הסיסמה שלך",
        "ResetLinkAlert_Subtitle": "יש ללחוץ על קישור איפוס הסיסמה שנשלח באימייל כדי להגדיר סיסמה חדשה ולהתחבר לחשבון.",
        "PasswordNotSetAlert_Message": "הסיסמה לא הוגדרה, יש להתחבר באמצעות ",
        "ResetYourPassword": {
            "MainTitle": "צפייה בתוצאות הראיון שלך ב-Hubert",
            "Subtitle": "אפשר להתחבר כדי לראות תוצאות, לקבל משוב, לקרוא עצות ועוד.",
            "FormSectionTitle": "איפוס הסיסמה שלך",
            "Label_NewPassword": "סיסמה חדשה",
            "Label_ConfirmNewPassword": "אישור הסיסמה החדשה",
            "Error_NewPassword_Required": "יש להזין סיסמה חדשה.",
            "Error_Password_6_Characters": "הסיסמה החדשה חייבת להכיל לפחות 6 תווים.",
            "Error_ConfirmNewPassword_Required": "יש לאשר את הסיסמה החדשה.",
            "Error_ConfirmNewPassword_NotMatch": "הסיסמה אינה תואמת לסיסמה החדשה.",
            "Error_MalformedResetUrl": "קוד האבטחה אינו תקין. אפשר לנסות שוב.",
            "Error_ResetPasswordFailed": "אירעה בעיה באיפוס הסיסמה. אפשר לנסות שוב.",
            "Error_WeakPassword": "הסיסמה חייבת להכיל לפחות 6 תווים.",
            "Error_InvalidCode_Title": "בקשת איפוס הסיסמה פגה או אינה תקינה.",
            "Error_InvalidCode_Subtitle": "אפשר לנסות לאפס את הסיסמה שוב.",
            "ButtonText_SetNewPassword": "הגדרת סיסמה חדשה והתחברות",
            "ButtonText_RememberYourPassword": "חזרה להתחברות",
            "ButtonText_SignInInstead": "התחברות במקום זאת"
        }
    },
    "PageNotFound": {
        "Title": "הדף לא נמצא",
        "Description": "לא הצלחנו למצוא את הדף שחיפשת.",
        "ButtonText_GoToDashboard": "ללוח הבקרה",
        "ButtonText_GoToLogin": "להתחברות"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "שימוש חוזר בתשובות עדיין לא זמין לראיון הזה. אנחנו מקווים שהתכונה תהיה זמינה בקרוב, אבל בינתיים אפשר להמשיך לראיון כרגיל.",
        "DescriptionLine2": "יש ללחוץ על הכפתור למטה כדי להמשיך בראיון.",
        "ButtonText_TakeMeToTheInterview": "לראיון"
    },
    "UnsubscribeFromEmails": {
        "Title": "להמשיך בביטול ההרשמה?",
        "Subtitle": "לא יישלחו עוד אימיילים מאיתנו לגבי המשרה הזו:",
        "SelectTheReason": "יש לבחור סיבה מהאפשרויות שבהמשך.",
        "ReasonText1": "מצאתי משרה אחרת.",
        "ReasonText2": "אין עוד עניין במשרה הזו.",
        "ReasonText3": "אחר",
        "ButtonText_Unsubscribe": "ביטול הרשמה למשרה הזו",
        "Placeholder_YourReason": "הסיבה שלך",
        "Success_Title": "קבלת האימיילים לגבי המשרה הזו בוטלה בהצלחה.",
        "Loading": "טוען...",
        "Error_YourReason_Required": "יש להזין סיבה.",
        "Error_ServerIssue": "לא הצלחנו לבטל את ההרשמה עקב שגיאת שרת."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "לנסות שוב"
    },
    "Outreach": {
        "CandidateNotFound": "המועמד לא נמצא",
        "CandidateNotFoundDesc": "לא נמצאו פרטי הראיון המבוקשים.",
        "InterviewEnded": "הראיון הסתיים",
        "InterviewEndedDesc1": "סשן הראיון הזה הסתיים או אינו זמין יותר.",
        "InterviewEndedDesc2": "תודה על הזמן שהוקדש. לשאלות נוספות, אפשר לפנות לצוות הגיוס.",
        "ReadyTitle": "הכול מוכן לראיון, {{firstName}}?",
        "InvitationDesc": "Hubert, בשם {{companyName}}, מזמין אותך לראיון בצ'אט. זה לוקח בערך 1–2 דקות.",
        "Button_StartChat": "התחלת ראיון צ'אט",
        "CancelNotice": "התחלה מכאן תבטל את השיחה המתוזמנת לתפקיד הזה.",
        "PreferNotToContinue": "לא מתאים להמשיך?",
        "DeclineLabel": "אין לי עניין בתפקיד הזה. בבקשה אל תתקשרו ואל תשלחו לי הודעות נוספות לגבי המשרה הזו.",
        "Button_ConfirmAndDecline": "אישור וסירוב",
        "Processing": "מעבד...",
        "Toast_DeclineSuccess": "הראיון נדחה.",
        "Toast_CancelVoiceInfo": "השיחה בוטלה. התכונה תגיע בקרוב.",
        "Toast_CancelError": "לא הצלחנו לבטל את הראיון. אפשר לנסות שוב.",
        "Footer_WithdrawConsent": "אפשר לבטל את ההסכמה בכל עת. מידע נוסף מופיע במדיניות הפרטיות של ",
        "Footer_PrivacyPolicySuffix": "",
        "Footer_And": " ו ",
        "Footer_HubertPrivacyLink": "מדיניות הפרטיות ותנאי השימוש של Hubert",
        "Chat_InterviewWith": "ראיון עם {{companyName}}",
        "Chat_StatusConnected": "מחובר",
        "Chat_StatusError": "שגיאה",
        "Chat_StatusDisconnected": "מנותק",
        "Chat_StatusConnecting": "מתחבר...",
        "Chat_ReadyToStart": "אפשר להתחיל את הראיון?",
        "Chat_ButtonStart": "התחלת הראיון",
        "Chat_SayHello": "אפשר לומר שלום כדי להתחיל את השיחה.",
        "Chat_EmptyState": "יש לשלוח הודעה כדי להתחיל את הראיון.",
        "Chat_SelectLanguage": "בחירת השפה המועדפת",
        "Chat_Placeholder": "הקלדת הודעה...",
        "Chat_ButtonSend": "שליחה",
        "Chat_ButtonBack": "חזרה",
        "LoadingCandidateDetails": "טוענים את פרטי המועמד...",
        "FetchingCandidateDetails": "מאחזרים את פרטי המועמד...",
        "Chat_StatusReady": "בהמתנה לחיבור...",
        "Chat_ForbiddenError": "ראיון הצ'אט הזה אינו זמין יותר.",
        "Chat_GeneralError": "לא הצלחנו להתחיל את הצ'אט. אפשר לנסות שוב מאוחר יותר.",
        "Chat_SelectUiLanguage": "שפת ממשק",
        "Chat_InterviewTitle": "ראיון עבודה"
    }
}
